import { getTradesTapeTopic } from "@/lib/natsConnection";
import { useCallback } from "react";
import { useGenericSocket } from "./useGenericSocket";

export interface ITradesBySymbol {
  timestamp: number;
  symbol: string;
  aggTrade: {
    a: number; // Aggregate trade ID
    p: string; // Price
    q: string; // Quantity
    f: number; // First trade ID
    l: number; // Last trade ID
    T: number; // Timestamp
    m: boolean; // Is buyer market maker
  };
}

export function useTradesBySymbol(symbol: string) {
  const handler = useCallback(
    (_: ITradesBySymbol | null, newData: ITradesBySymbol) => {
      return newData;
    },
    [],
  );

  return useGenericSocket<ITradesBySymbol, ITradesBySymbol>(
    getTradesTapeTopic(symbol),
    handler,
  );
}
